<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BwdnzH/tc-custom/9781473835153.jpg?1702083301518" alt="This image is the cover for the book Tank Tracks to Rangoon"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tank Tracks to Rangoon
      </h1>
      <p class="bookDescription body article font2">
        <b>A look at how British and Indian forces used tank warfare against the Japanese during World War II in modern-day Myanmar.</b><br/><br/> Fighting in a somewhat forgotten corner of empire during the Second World War, the British and Indian armored regiments called upon to harness the power of tank warfare to extreme new levels did so in an effort to outwit an army until that point considered invincible: the Imperial Japanese Army. Their collective heroic, massively effective efforts gave the Japanese a taste of mechanized warfare from which they never recovered.<br/><br/> Author Bryan Perrett describes the full course of the armored units’ endeavors, illustrating the importance of the mighty 7th Armoured Brigade; a “magnificent formation” in General Slim’s estimation. In a conflict that saw much development in the field of tank design and production, Perrett illustrates the practical repercussions of such advances in this most extreme of wartime environments. Detailed research has produced hard evidence of the Japanese use of gas against British tanks, and countless instances of Japan’s human-bomb anti-tank technique. Above all, this book shows to what extent the tank can prove a decisive weapon in the unlikeliest areas.<br/><br/><b>Praise for <i>Tank Tracks to Rangoon</i></b><br/><br/><b>“A valuable examination of the crucial role [armor] played in the long Burmese campaign, and the impressive way in which the British and Allied tanks and tankers performed their difficult duties.” —History of War</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bryan Perrett
      </h2>
      
      <p class="authorDescription body article">Bryan Perrett was educated at Liverpool College. He served in the Royal Tank Regiment and was awarded the Territorial Decoration. A professional military historian for many years, his books include A History of the Blitzkrieg and Knights of the Black Cross: Hitler's Panzerwaffe and its Leaders. His treatise Desert Warfare was widely consulted during the Gulf War. His most recent works, including Last Stand!, At All Costs! and Against all Odds! examine aspects of motivation. During the Falklands and Gulf Wars, Bryan Perrett served as Defense Correspondent to the Liverpool Echo. He is the author of The Hunters and the Hunted (2012), Why the Germans Lost (2013) and Why the Japanese Lost (2014), all published by Pen & Sword Books.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen & Sword Military
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3f425a00